import {z} from 'zod/v4';

export const siteKinds = [
  'webflow',
  'campaign',
  'tutorial',
  'cloudapp',
  'optimize',
] as const;

export const SiteKind = z.enum(siteKinds);

export type SiteKind = z.infer<typeof SiteKind>;
